import {StyleSheet} from 'react-native';
import {Colors} from '../../../../../../constants/Colors';

export const styles = StyleSheet.create({
  card: {
    height: 131,
    width: '100%',
    backgroundColor: 'white',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    // paddingHorizontal: 5,
    marginTop: 20,
    paddingVertical: 10,
    borderBottomWidth: 1,
    borderColor: Colors.GrayPallete.lightgray,
  },
  spaceItens: {
    alignItems: 'baseline',
    justifyContent: 'space-between',
  },
  description: {
    maxWidth: 230,
    textAlign: 'left',
    fontSize: 12,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 16,
    color: Colors.GrayPallete.lightgrayThree,
    marginBottom: 5,
  },
  spaceA: {
    justifyContent: 'space-around',
  },
  deleteText: {
    fontSize: 10,
    lineHeight: 16,
    color: Colors.GrayPallete.lightgrayTwo,
    fontFamily: 'TCCC-UnityHeadline Regular',
    alignSelf: 'flex-end',
  },
  priceText: {
    fontSize: 10,
    lineHeight: 12,
    color: 'black',
    fontFamily: 'TCCC-UnityHeadline Regular',
  },
  cardWTrash: {
    height: 131,
    width: '80%',
    backgroundColor: 'white',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 15,
    shadowColor: 'rgba(0,0,0,0.5)',
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.2,
    shadowRadius: 1.41,
    elevation: 2,
    marginTop: 20,
    borderRadius: 12,
    paddingVertical: 10,
  },
  deleteTextActive: {
    fontSize: 10,
    lineHeight: 16,
    color: Colors.RedPallete.red,
    fontFamily: 'TCCC-UnityHeadline Regular',
    alignSelf: 'flex-end',
  },
  containerPrice: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  image: {
    width: 100,
    height: 100,
    marginRight: 5,
    alignSelf: 'flex-start',
  },
  price: {
    maxWidth: 230,
    fontSize: 10,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 16,
    color: Colors.GrayPallete.lightgrayThree,
    marginBottom: 5,
  },
});
